export const isPartner = (accountId: string) => {
    return Boolean(accountId) && accountId.endsWith("00000");
};

export const getOrigin = (d: Document) => {
    const origin = d.location && d.location.origin;
    if (!origin) {
        throw new Error(`Unable to get document.location.origin`);
    }
    return origin;
};
